// extracted by mini-css-extract-plugin
export default {"businessTemplates":"DemoPromoTooltip__businessTemplates--3nIYk","content":"DemoPromoTooltip__content--HaeLa"};